import { lazy } from 'react';
import { Navigate, useRoutes } from 'react-router-dom';
// layouts
import PrivateRoute from 'components/privateRoute';
import SimpleLayout from './layouts/simple';
import DashboardLayout from 'layouts/dashboard/DashboardLayout';

import { LandingPage } from 'pages/LandingPage';

const ProductAndTypesPage = lazy(() => import('pages/ProductAndTypesPage/ProductAndTypesPage'));
const AddProductTypePage = lazy(() =>
  import('pages/ProductAndTypesPage/_components/AddProductTypePage')
);
const EditProductTypePage = lazy(() =>
  import('pages/ProductAndTypesPage/_components/EditProductTypePage')
);
const ClientsPage = lazy(() => import('pages/ClientsPage'));
const AddClientPage = lazy(() => import('pages/AddClientPage'));
const EditClientPage = lazy(() => import('pages/EditClientPage'));
const EditTradePage = lazy(() => import('pages/ClientViewPage/EditTradePage'));
const EditOutcomePage = lazy(() => import('pages/ClientViewPage/EditOutcomePage'));
const EditIncomePage = lazy(() => import('pages/ClientViewPage/EditIncomePage'));
const EditDiscountPage = lazy(() => import('pages/ClientViewPage/EditDiscountPage'));
const EditPaymentPage = lazy(() => import('pages/ClientViewPage/EditPaymentPage'));
const EditAdditionalServicePage = lazy(() =>
  import('pages/ClientViewPage/EditAdditionalServicePage')
);
const UserPage = lazy(() => import('pages/UsersPage'));
const AddUserPage = lazy(() => import('pages/AddUserPage'));
const EditUserPage = lazy(() => import('pages/EditUserPage'));
const LoginPage = lazy(() => import('pages/LoginPage'));
const OpenAccountPage = lazy(() => import('pages/OpenAccountPage'));
const DashboardPage = lazy(() => import('pages/DashboardPage'));
const ClientViewPage = lazy(() => import('pages/ClientViewPage/ClientViewPage'));
const TradeViewPage = lazy(() => import('pages/ClientViewPage/TradeViewPage'));
const StoragesPage = lazy(() => import('pages/StoragesPage/StoragesPage'));
const AddStorageActionPage = lazy(() => import('pages/StoragesPage/AddStorageActionPage'));
const EditStorageActionPage = lazy(() => import('pages/StoragesPage/EditStorageActionPage'));
const SettingsPage = lazy(() => import('pages/SettingsPage'));
const HowSystemWorksPage = lazy(() => import('pages/HowSystemWorksPage'));

export default function Router() {
  const routes = useRoutes([
    {
      path: '/',
      element: <LoginPage />,
      index: true
    },
    {
      path: '/login',
      element: <Navigate to="/" replace />
    },
    {
      path: '/about',
      element: <LandingPage />
    },
    {
      path: '/open-account',
      element: <OpenAccountPage />
    },
    {
      path: '/dashboard',
      element: (
        <PrivateRoute>
          <DashboardLayout />
        </PrivateRoute>
      ),
      children: [
        { element: <Navigate to="/dashboard/clients" />, index: true },
        { path: 'app', element: <DashboardPage /> },
        { path: 'user', element: <UserPage /> },
        { path: 'user/add', element: <AddUserPage /> },
        { path: 'user/edit/:id', element: <EditUserPage /> },

        { path: 'products', element: <ProductAndTypesPage /> },
        { path: 'product-types/add', element: <AddProductTypePage /> },
        { path: 'product-types/edit/:id', element: <EditProductTypePage /> },

        { path: 'clients', element: <ClientsPage /> },
        { path: 'clients/add', element: <AddClientPage /> },
        { path: 'clients/edit/:id', element: <EditClientPage /> },
        { path: 'clients/view/:id', element: <ClientViewPage /> },
        { path: 'clients/view/:id', element: <ClientViewPage /> },

        { path: 'trades/view/:id', element: <TradeViewPage /> },

        { path: 'clients/:clientID/trades/edit/:tradeID', element: <EditTradePage /> },
        { path: 'clients/:clientID/payments/edit/:paymentID', element: <EditPaymentPage /> },
        { path: 'clients/:clientID/discounts/edit/:paymentID', element: <EditDiscountPage /> },
        { path: 'trades/:tradeID/outcomes/edit/:outcomeID', element: <EditOutcomePage /> },
        { path: 'trades/:tradeID/incomes/edit/:incomeID', element: <EditIncomePage /> },
        {
          path: 'trades/:tradeID/additional-services/edit/:serviceID',
          element: <EditAdditionalServicePage />
        },
        { path: 'storages', element: <StoragesPage /> },
        { path: 'storages/add', element: <AddStorageActionPage /> },
        { path: 'storages/edit/:id', element: <EditStorageActionPage /> },
        { path: 'settings', element: <SettingsPage /> },
        { path: 'how-it-works', element: <HowSystemWorksPage /> }
      ]
    },
    {
      element: <SimpleLayout />,
      children: [
        { element: <Navigate to="/dashboard/clients" />, index: true },
        { path: '*', element: <Navigate to="/" /> }
      ]
    },
    {
      path: '*',
      element: <Navigate to="/dashboard/clients" replace />
    }
  ]);

  return routes;
}
